import React from 'react'
import { useRouter } from 'next/router'
import PostContainer from '@components/blog/pages/PostContainer'

import PostMainPhoto from '@components/blog/components/post/PostMainPhoto'
import PostHeading from '@components/blog/components/post/PostHeading'
import PostMeta from '@components/blog/components/post/PostMeta'
import PostContent from '@components/blog/components/post/PostContent'
import PostNavigation from '@components/blog/components/post/PostNavigation'
import ConnectedAdsSections from '@components/blog/components/post/ConnectedAdsSections'
import YouMightAlsoLike from '@components/blog/components/post/YouMightAlsoLike'
import FacebookShareLike from '@components/facebook/FacebookShareLike'
import withBreakpoints from '@hoc/withBreakpoints'
import AddOfferButton from './AddOfferButton'

import { postImage } from '@components/blog/utils/postLinks'
import PHOTO_TYPES from '@constants/articles/photoTypes'

import useT from '@hooks/useTranslation'

import styles from '@components/blog/styles/Post.module.css'

function Post ({
    article,
    breakpoints: { onMobile, onWrapperSqueeze },
    connectedAds,
    nextArticle,
    prevArticle,
    similar,
}) {

    const heroProps = mainPhotoPropsFromArticle(article)
    const router = useRouter()

    const hasConnectedAds =
           (typeof connectedAds === 'object' && Object.keys(connectedAds).length > 0)
        || (Array.isArray(connectedAds) && connectedAds.length > 0)

    const displayAddButtonOnTop = !onMobile || (onMobile && !hasConnectedAds)
    const displayAddButtonOnBottom = hasConnectedAds

    const edgeMargin = onWrapperSqueeze
        ? -20
        : 'calc(-1 * ((100vw - 900px)/2))'

    const addButtonTop = displayAddButtonOnTop && <AddOfferButton />
    const addButtonBottom = displayAddButtonOnBottom && <AddOfferButton style={{ marginLeft: edgeMargin, marginRight: edgeMargin }} />
    return (
        <>
            { addButtonTop }
            <PostContainer>
                <header className={styles.container}>
                    <PostMainPhoto {...heroProps} />
                    <PostHeading {...article} />
                </header>

                <PostMeta {...article} className={styles.container} />
                <PostContent {...article} />
                <div className={styles.container}>
                    <FacebookShareLike url={router.asPath} text={useT('Udostępnij')} />
                </div><br/><br/>

                <aside className={styles.container}>
                    <PostNavigation {...{ prevArticle, nextArticle }} />
                    <br/>
                    { addButtonBottom }
                    <ConnectedAdsSections connectedAds={connectedAds} />
                    <YouMightAlsoLike posts={similar} />
                </aside>
            </PostContainer>
        </>
    )
}

function mainPhotoPropsFromArticle ({ photosExist, tracking: { pid }, title, imgAlt, imgTitle }) {
    if (photosExist.includes(PHOTO_TYPES.indexOf('mainPhoto'))) {
        return {
            src: postImage({ tracking: { pid }}),
            alt: imgAlt || title,
            title: imgTitle || imgAlt || title,
        }
    }
}

export default
    withBreakpoints({ onMobile: 800, onWrapperSqueeze: 899 })(
        Post)